import { fromLatLng, setKey, setLanguage, setRegion } from 'react-geocode';

import {
    FETCH_GEOCODE_POINT,
    FETCH_GEOCODE_POINT_FAILURE,
    FETCH_GEOCODE_POINT_SUCCESS,
} from '../actionTypes';
import { creditFileActions } from '../reducer';

export default (lat, lng) => (dispatch) => {
    setKey(import.meta.env.VITE_GOOGLE_MAPS_KEY);
    setLanguage('es-MX');
    setRegion('mx');

    dispatch(creditFileActions[FETCH_GEOCODE_POINT]());

    return fromLatLng(lat, lng).then(
        (response) =>
            dispatch(
                creditFileActions[FETCH_GEOCODE_POINT_SUCCESS](
                    response.results[0].formatted_address,
                ),
            ),
        (error) =>
            dispatch(
                creditFileActions[FETCH_GEOCODE_POINT_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
    );
};
